{
  "close": "닫기",
  "notifications": "알림"
}
